// extracted by mini-css-extract-plugin
var _1 = "EmailProfileMessageHeaderActions-moduleEmailProfileMessageHeaderActions__IkDRC";
var _2 = "EmailProfileMessageHeaderActions-moduleaction__PWoT9";
export { _1 as "EmailProfileMessageHeaderActions", _2 as "action" }
